import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <a href="/mentions-legales" className="legal-notice">Mentions Légales</a>
        <p className='footer-copyright'>© 2024 Strong Fit - Tous droits réservés.</p>
      </div>
    </footer>
  );
};

export default Footer;
